export default {
    bjfTotal: (state) => {
        const bjf = state.sessions.filter((session) => session.bjf);
        
        let total = {
            waiting: 0,
            processing: 0,
            uploaded: 0
        }

        bjf.forEach((activity) => {
            if (activity.bjf.is_uploading == 0) {
                total.waiting += 1;
                return;
            }

            if (activity.bjf.is_uploading == 1 && activity.bjf.notification_sent == 0) {
                total.processing += 1;
                return;
            }

            if (activity.bjf.is_uploading == 1 && activity.bjf.notification_sent == 1) {
                total.uploaded += 1;
                return;
            }
        })

        return total;
    },
    bjsTotal: (state) => {
        const bjs = state.sessions.filter((session) => session.bjs);
        
        let total = {
            waiting: 0,
            processing: 0,
            uploaded: 0
        }

        bjs.forEach((activity) => {
            if (activity.bjs.is_uploading == 0) {
                total.waiting += 1;
                return;
            }

            if (activity.bjs.is_uploading == 1 && activity.bjs.notification_sent == 0) {
                total.processing += 1;
                return;
            }

            if (activity.bjs.is_uploading == 1 && activity.bjs.notification_sent == 1) {
                total.uploaded += 1;
                return;
            }
        })

        return total;
    },
    sjfTotal: (state) => {
        const sjf = state.sessions.filter((session) => session.sjf);
        
        let total = {
            waiting: 0,
            processing: 0,
            uploaded: 0
        }

        sjf.forEach((activity) => {
            if (activity.sjf.is_uploading == 0) {
                total.waiting += 1;
                return;
            }

            if (activity.sjf.is_uploading == 1 && activity.sjf.notification_sent == 0) {
                total.processing += 1;
                return;
            }

            if (activity.sjf.is_uploading == 1 && activity.sjf.notification_sent == 1) {
                total.uploaded += 1;
                return;
            }
        })

        return total;
    },
    sjsTotal: (state) => {
        const sjs = state.sessions.filter((session) => session.sjs);
        
        let total = {
            waiting: 0,
            processing: 0,
            uploaded: 0
        }

        sjs.forEach((activity) => {
            if (activity.sjs.is_uploading == 0) {
                total.waiting += 1;
                return;
            }

            if (activity.sjs.is_uploading == 1 && activity.sjs.notification_sent == 0) {
                total.processing += 1;
                return;
            }

            if (activity.sjs.is_uploading == 1 && activity.sjs.notification_sent == 1) {
                total.uploaded += 1;
                return;
            }
        })

        return total;
    },
    swTotal: (state) => {
        const sw = state.sessions.filter((session) => session.sw);
        
        let total = {
            notAssigned: 0,
            waiting: 0,
            processing: 0,
            uploaded: 0
        }

        sw.forEach((activity) => {
            if ((activity.sw.activity == 'SW' || activity.sw.activity == 'TC') && !activity.sw.group_number) {
                total.notAssigned += 1;
                return;
            }

            if(!activity.sw.parent) {
                if (activity.sw.is_uploading == 0) {
                    total.waiting += 1;
                    return;
                }
    
                if (activity.sw.is_uploading == 1 && activity.sw.notification_sent == 0) {
                    total.processing += 1;
                    return;
                }
    
                if (activity.sw.is_uploading == 1 && activity.sw.notification_sent == 1) {
                    total.uploaded += 1;
                    return;
                }
            } else {
                if (activity.sw.parent.is_uploading == 0) {
                    total.waiting += 1;
                    return;
                }

                if (activity.sw.parent.is_uploading == 1 && activity.sw.parent.notification_sent == 0) {
                    total.processing += 1;
                    return;
                }

                if (activity.sw.parent.is_uploading == 1 && activity.sw.parent.notification_sent == 1) {
                    total.uploaded += 1;
                    return;
                }
            }
        })

        return total;
    },
    tcTotal: (state) => {
        const tc = state.sessions.filter((session) => session.tc);
        
        let total = {
            notAssigned: 0,
            waiting: 0,
            processing: 0,
            uploaded: 0
        }

        tc.forEach((activity) => {
            if ((activity.tc.activity == 'SW' || activity.tc.activity == 'TC') && !activity.tc.group_number) {
                total.notAssigned += 1;
                return;
            }

            if(!activity.tc.parent) {
                if (activity.tc.is_uploading == 0) {
                    total.waiting += 1;
                    return;
                }
    
                if (activity.tc.is_uploading == 1 && activity.tc.notification_sent == 0) {
                    total.processing += 1;
                    return;
                }
    
                if (activity.tc.is_uploading == 1 && activity.tc.notification_sent == 1) {
                    total.uploaded += 1;
                    return;
                }
            } else {
                if (activity.tc.parent.is_uploading == 0) {
                    total.waiting += 1;
                    return;
                }

                if (activity.tc.parent.is_uploading == 1 && activity.tc.parent.notification_sent == 0) {
                    total.processing += 1;
                    return;
                }

                if (activity.tc.parent.is_uploading == 1 && activity.tc.parent.notification_sent == 1) {
                    total.uploaded += 1;
                    return;
                }
            }
        })

        return total;
    },
    focTotal: (state) => {
        const sessions = state.sessions;
        let total = 0;

        sessions.forEach((session) => {
            if(session.sw && !session.bjf && !session.bjs && !session.sjf && !session.sjs && !session.tc) { 
                total += 1;
            }
        });
    
        return total;
    },
}